import React from 'react';
import useMain from '../../../hooks/useMain';
import getCSSVars from '../../../utils/getCSSVars';
import Hash from './../../common/hash';

const HistoryTable = ({ data }) => {
	const { theme } = useMain();
	return (
		<div className='table-responsive'>
			<table className='table table-sm myTable text-center'>
				<thead>
					<tr>
						<th>#</th>
						<th>Date</th>
						<th>Amount</th>
						<th>Description</th>
					</tr>
				</thead>
				<tbody>
					{data.map((d, key) => (
						<tr key={key}>
							<td>{d.no}</td>
							<td>{new Date(d.date).toLocaleString()}</td>
							<td>{d.amount / 1e6} USDT</td>
							<td>
								{d.hash ? (
									<Hash
										hash={d.hash}
										color={getCSSVars('text-set3')}
									/>
								) : (
									d.action
								)}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default HistoryTable;
